import {NavianceSchool} from "../../models/school/naviance-school.model";
import {CleverSchool} from "../../models/school/clever-school.model";

export interface AddressService {
    getNavianceSchoolAddressLine(navianceSchool: NavianceSchool): string;
    getNavianceSchoolCityStateZip(navianceSchool: NavianceSchool): string;
    getCleverSchoolAddress(cleverSchool: CleverSchool): string;
    getCleverSchoolCityStateZip(cleverSchool: CleverSchool): string;
    searchByAddress (cleverSchool: CleverSchool, searchText: string): boolean;
}

/* @ngInject */
export function addressService(): AddressService {
    let csz = (city: string, state: string, zip: number): string => {
        return `${city ? `${city}, ` : ""}${state} ${zip}`;
    };

    return {
        getNavianceSchoolAddressLine: (navianceSchool: NavianceSchool): string => {
            if (!navianceSchool) {
                return;
            }
            let addressLine = navianceSchool.addressLine1 ? `${navianceSchool.addressLine1}, ` : "";
            return `${addressLine}${navianceSchool.addressLine2 ? navianceSchool.addressLine2 : ""}`;
        },
        getNavianceSchoolCityStateZip: (navianceSchool: NavianceSchool): string => {
            if (!navianceSchool) {
                return;
            }
            return csz(navianceSchool.city, navianceSchool.state, navianceSchool.zip);
        },
        getCleverSchoolAddress: (cleverSchool: CleverSchool): string => {
            if (!cleverSchool) {
                return;
            }
            return cleverSchool.location.address ? cleverSchool.location.address : "";
        },
        getCleverSchoolCityStateZip: (cleverSchool: CleverSchool): string => {
            if (!cleverSchool) {
                return;
            }
            return csz(cleverSchool.location.city, cleverSchool.location.state, cleverSchool.location.zip);
        },
        searchByAddress: (cleverSchool: CleverSchool, searchText: string): boolean => {
            return (cleverSchool.location.city.toLowerCase() + cleverSchool.location.state.toLowerCase() + 
                cleverSchool.location.zip).indexOf(searchText.toLowerCase()) >= 0;
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/address/address.service.ts